export const getTgNickNameByLink = (link: string) => {
    const splitedLink = link.split('t.me/');
    return splitedLink[splitedLink.length - 1] || 'Неизвестно';
};
